import { AVATAR_COLORS } from "../Meetings/Meetings.utils";

export const getAvatarColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash += name.charCodeAt(i);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

export const buildAuthorMap = (messages = []) => {
  const map = {};
  messages.forEach((msg) => {
    const channels =
      msg.integrationSettingId?.defaultSettings?.find(
        (s) => s.name === "channels",
      )?.data || [];
    channels.forEach((ch) => {
      (ch.members || []).forEach((m) => {
        if (m.userId && !map[m.userId]) {
          map[m.userId] = m.name;
        }
      });
    });
  });
  return map;
};

export const resolveAuthor = (authorId, authorMap) => {
  if (!authorId) return "Unknown";
  if (authorMap[authorId]) return authorMap[authorId];
  return authorId.length > 12 ? authorId.slice(0, 8) + "…" : authorId;
};

export const resolveMentions = (text = "", authorMap = {}) => {
  return text.replace(/<@([A-Z0-9a-z_-]+)>/g, (match, userId) => {
    return authorMap[userId] ? `@${authorMap[userId]}` : match;
  });
};